import { ITaskSimple } from '../app/resource/task-simple/task-simple.types';

/**
 * Sorts done tasks by `completedAt`, falling back to `changedAt` when completion date is missing.
 * Newest dates appear first. Tasks without either date keep their relative order.
 */
export const sortDoneTasksByCompletedOrChangedAt = (tasks: (ITaskSimple | null)[]): ITaskSimple[] => {
  return tasks
    .filter((task): task is ITaskSimple => task !== null)
    .sort((a, b) => {
      const dateForSortA = a.completedAt || a.changedAt;
      const dateForSortB = b.completedAt || b.changedAt;

      if (!dateForSortA || !dateForSortB) {
        return 0;
      }

      const dateA = new Date(dateForSortA);
      const dateB = new Date(dateForSortB);

      return dateB.getTime() - dateA.getTime();
    });
};

export const sortTasksByDate = (
  tasks: (ITaskSimple | null)[],
  dateField: 'changedAt' | 'completedAt',
  direction: 'ASC' | 'DES',
) => {
  return tasks
    .filter((task): task is ITaskSimple => task !== null)
    .sort((a: ITaskSimple, b: ITaskSimple) => {
      const primaryDate = a[dateField];
      const secondaryDate = b[dateField];

      if (primaryDate && secondaryDate) {
        const dateA = new Date(primaryDate);
        const dateB = new Date(secondaryDate);
        return direction === 'ASC' ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
      }

      // Null go down
      if (!primaryDate) {
        return 1;
      } // a is null, b is not null
      if (!secondaryDate) {
        return -1;
      } // b is null, a is not null

      return 0; // a and b are null
    });
};
